<div class="campaign-detail">
  <div class="header">
    <h3>{{campaign?.subject}}</h3>
    <div class="btns">
      <button class="button" (click)="previewEmail()">Preview Email</button>
      <button class="button" (click)="cancelCampaign()" [disabled]="campaign?.status === 'completed' || campaign?.status === 'failed' || campaign?.status === 'cancelled'">
        Cancel Campaign
      </button>
      <button class="button" (click)="close()">Back to list</button>
    </div>
  </div>
  <p class="note">Cancelling only stops recipients not yet handed off to SMTP; messages already accepted cannot be retracted.</p>

  <app-loader *ngIf="loading"></app-loader>

  <div class="campaign-summary" *ngIf="campaign && !loading">
    <p>From: {{campaign.from_email}}</p>
    <p>BCC Policy: {{campaign.bcc_policy}}</p>
    <p>Created: {{campaign.created_at | date:'short'}} &nbsp; by: {{creatorName}}</p>
    <p>Intended: {{campaign.intended_recipient_count}} &nbsp; Accepted (SMTP): {{campaign.accepted_recipient_count}}
      &nbsp; Delivered: {{campaign.delivered_recipient_count === null ? '—' : campaign.delivered_recipient_count}}</p>
  </div>

  <app-campaign-status-bar [status]="campaignStatus" [pollError]="pollError" [pollFailed]="pollFailed"></app-campaign-status-bar>

  <div class="reconciliation" *ngIf="reconciliation">
    <h5>Reconciliation</h5>
    <p>
      Intended: {{reconciliation.intended}} &nbsp;
      Queued: {{reconciliation.queued}} &nbsp;
      Started: {{reconciliation.started}} &nbsp;
      Accepted (SMTP): {{reconciliation.accepted}} &nbsp;
      Failed: {{reconciliation.failed}} &nbsp;
      Unknown: {{reconciliation.unknown}}
    </p>
  </div>

  <section class="included-playlists" *ngIf="campaign && !loading">
    <h5>Included Playlists</h5>
    <p class="note" *ngIf="!campaign.playlists?.length">No playlists included.</p>
    <ul *ngIf="campaign.playlists?.length">
      <li *ngFor="let playlist of campaign.playlists">
        <span>{{playlist.playlist_name}} <span class="playlist-id">#{{playlist.playlist_id}}</span></span>
        <span class="playlist-action">{{playlist.add_to_account ? 'Added to recipient accounts' : 'Included in email'}}</span>
      </li>
    </ul>
  </section>

  <div class="recipients">
    <h5>Recipients</h5>
    <p class="note">Sent to groups: {{sourceGroupNames}}</p>
    <mat-form-field appearance="fill" class="dark-theme">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="statusFilter" (selectionChange)="filterRecipients()">
        <mat-option value="">All</mat-option>
        <mat-option value="intended">Intended</mat-option>
        <mat-option value="queued">Queued</mat-option>
        <mat-option value="started">Started</mat-option>
        <mat-option value="accepted">Accepted (SMTP)</mat-option>
        <mat-option value="failed">Failed</mat-option>
        <mat-option value="retrying">Retrying</mat-option>
        <mat-option value="delivered">Delivered</mat-option>
        <mat-option value="bounced">Bounced</mat-option>
        <mat-option value="deferred">Deferred</mat-option>
        <mat-option value="complained">Complained</mat-option>
        <mat-option value="suppressed">Suppressed</mat-option>
        <mat-option value="unknown">Unknown</mat-option>
        <mat-option value="cancelled">Cancelled</mat-option>
      </mat-select>
    </mat-form-field>
    <p class="note" *ngIf="recipientsLoading" role="status">Loading all recipients...</p>
    <div *ngIf="recipientsError" role="alert">
      <p>{{recipientsError}}</p>
      <button class="button" (click)="loadRecipients()">Retry</button>
    </div>
    <p class="note" *ngIf="!recipientsLoading && !recipientsError">
      {{recipients.length}} recipient(s){{statusFilter ? ' matching this status' : ''}}
    </p>
    <div class="recipients-scroll" role="region" aria-label="Campaign recipients" tabindex="0"
      *ngIf="!recipientsLoading && !recipientsError && recipients.length">
      <table class="recipients-table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Type</th>
            <th>Status</th>
            <th>BCC</th>
            <th>Attempts</th>
            <th>Accepted At</th>
            <th>Delivered At</th>
            <th>Last Error</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let recipient of recipients; trackBy:recipientTrackBy">
            <td>{{recipient.recipient_email}}</td>
            <td>{{recipient.recipient_type}}</td>
            <td>{{recipient.status}}</td>
            <td>{{recipient.bcc_intended ? 'Yes' : 'No'}}</td>
            <td>{{recipient.attempt_count}}</td>
            <td>{{recipient.accepted_at ? (recipient.accepted_at | date:'short') : '—'}}</td>
            <td>{{recipient.delivered_at ? (recipient.delivered_at | date:'short') : '—'}}</td>
            <td>{{recipient.last_error_message}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
